import { MouseEvent } from 'react';
import { SnippetLanguage } from 'components/snippet/SnippetLanguage';
import { DEFAULT_LANGUAGE } from 'components/snippet/constants';
import { CopyProps, Copy as SnippetCopy } from 'components/snippet/copy';
import { useCopy } from 'components/snippet/useCopy';
import { useSnippet } from 'components/snippet/useSnippet';
import 'highlight.js/styles/atom-one-light.css';
import { twMerge } from 'tailwind-merge';

interface SnippetProps {
    text?: string;
    language?: SnippetLanguage;
    copy?: boolean;
    copyProps?: CopyProps;
    // needed for copying text inside a modal. this will focus an open modal. creates a dependency on our modal, hope to figure out more decoupled way
    inPortal?: boolean;
    className?: string;
    onCopy?: any;
}

const Snippet = ({
    text = '',
    language = DEFAULT_LANGUAGE,
    copy = true,
    copyProps,
    inPortal = false,
    className,
    onCopy,
}: SnippetProps) => {
    const { formattedText, highlightedAndFormattedText } = useSnippet({
        language,
        text,
    });
    const { didCopy, onClickCopy } = useCopy({ onCopy, inPortal });
    const onClickCopyInternal = (e: MouseEvent<HTMLButtonElement>) => onClickCopy(e, formattedText);

    return (
        <div className={twMerge('relative max-w-xl', className)}>
            {copy && <Copy didCopy={didCopy} onClick={onClickCopyInternal} {...copyProps} />}
            <pre className="text-sm">
                <code className="hljs bg-gray-25 rounded-lg border border-gray-200 p-5">
                    <div
                        className="hljs-container"
                        dangerouslySetInnerHTML={{
                            __html: highlightedAndFormattedText,
                        }}
                    />
                </code>
            </pre>
        </div>
    );
};

const Root = Snippet;
const Copy = SnippetCopy;

export {
    Snippet,
    SnippetCopy,
    //
    Root,
    Copy,
};
export type { SnippetProps };
